import { VolunteeringHoursInfoSnippet } from './InfoSnippet';
import { VolunteeringHoursPlaceHolderSnippet } from './PlaceHolderSnippet';

export const VolunteeringHoursSnippets = {
  Info: VolunteeringHoursInfoSnippet,
  PlaceHolder: VolunteeringHoursPlaceHolderSnippet,
};
